// extracted by mini-css-extract-plugin
export default {"ReconnectingText":"ReconnectingText_ReconnectingText__4Um9u"};